import { getVirtualSessionsApiClient } from 'lib/SplashApiClient/subclients/VirtualSessionsApiClient';
import { downloadDataBlob } from './downloadDataBlob';

const virtualSessionsApiClient = getVirtualSessionsApiClient();

export const bulkDownloadCalendarAttachments = async (eventId, guestAccessHash) => {
    const calendarAttachment = await virtualSessionsApiClient.getSessionsCalendarsAttachment({
        eventId,
        guestAccessHash,
    });
    downloadDataBlob(calendarAttachment, 'calendar.ics', 'text/calendar; charset=utf-8');
};
